<template>
	<div class="page">
		<div class="list">
			<div class="list-item" v-for="item in images" :key="item.img">
				<img :src="item.img" alt="" />
			</div>
		</div>
		<div class="bot">
			<div class="bottomZ" />
			<div class="bottomBtnBox" @click="openBrowser">
				<img :src="require('@/assets/images/playGame/6.png')" alt="" />
			</div>
		</div>
	</div>
</template>

<script>
import AppLink from '@/components/Link'
import { invokeNative } from '@/utils/hybrid'
export default {
	name: 'playGame',
	components: { AppLink },
	data() {
		return {
			images: [
				{ img: require('@/assets/images/playGame/1.png'), link: '' },
				{ img: require('@/assets/images/playGame/2.png'), link: '' },
				{ img: require('@/assets/images/playGame/3.png'), link: '' },
				{ img: require('@/assets/images/playGame/4.png'), link: '' },
				{ img: require('@/assets/images/playGame/5.png'), link: '' },
			],
		}
	},
	methods: {
		openBrowser() {
			const i = window.location.href
			const url = i.split('#')[0] + `#/welfarePage?activeTab=0&hideNav=1`

			invokeNative({ methodName: 'playGame', url: encodeURIComponent(url) }, 'invokeMethod')
		},
	},
}
</script>

<style scoped lang="scss">
.list {
	
background: #E3391E;
	padding-bottom: 180px;
}
.list-item {
	display: block;
	font-size: 0;
	img {
		width: 100%;
		display: block;
	}
}
.bot {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	padding-bottom: constant(safe-area-inset-bottom);
	padding-bottom: env(safe-area-inset-bottom);

	.bottomZ {
		width: 100vw;
		height: 180px;
		left: 0;
		background-size: 100% 100%;
	}
	.bottomBtnBox {
		position: absolute;
		bottom: 20px;
		padding-bottom: constant(safe-area-inset-bottom);
		padding-bottom: env(safe-area-inset-bottom);
		width: 686px;
		left: 50%;
		transform: translateX(-50%);
	}
}
</style>
